import {useEffect, useRef, useState} from "react";
import {BiDownArrow} from "react-icons/bi";
import {IoIosArrowDown} from "react-icons/io";
import MenuDropdown from "../../../../components/dropdown/MenuDropdown/MenuDropdown";

export default function Filter({className, title, onChange, data, defaultValue,currentValue, options, ...props}) {
    const [value, setValue] = useState(defaultValue ? defaultValue : options.length > 0 ? options[0].value : "")
    const isfirstRender = useRef(true);
    useEffect(() => {
        if (isfirstRender.current) {
            isfirstRender.current = false;
            return;
        }
        if (onChange) onChange(value)
    }, [value])

    function getName() {
        if (currentValue){
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === currentValue) {
                    return options[i].name
                }
            }
        }
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value) {
                return options[i].name
            }
        }

        return ""
    }

    function handleSelect(value) {
        let sTitle = title.toLowerCase()
        if (props.select)
            props.select({
                ...props.selected,
                [sTitle]: value
            })


    }

    return (
        <MenuDropdown
            button={
                <div
                    className={` ${className} flex lg:min-w-[2vw] flex-col gap-1 cursor-pointer justify-center items-center`}>
                    <p className={"text-sm text-gray-300 text-center"}>
                        {title}
                    </p>
                    <div className={"flex flex-row gap-2  justify-center items-center"}>
                        <p className={"font-semibold "}>
                            {getName()}
                        </p>
                        <IoIosArrowDown className={"text-tertiary-900"}/>
                    </div>
                </div>
            }

            classNames={"py-2 top-12 -left-[172px] md:right-[12px] w-max"}
        >

            <div
                className="flex w-56 flex-col  justify-start rounded-lg bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-darkTheme-700 dark:text-white dark:shadow-none">

                {options.map((option, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => handleSelect(option.value)}
                            className={"justify-center border-b-[1px] py-1 hover:bg-gray-100 cursor-pointer items-center flex"}>
                            <p key={index} className={"font-semibold "}>
                                {option.name}
                            </p>

                        </div>

                    )
                })}
            </div>

        </MenuDropdown>

    )
}
